import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  shimmerBPTile: { height: 50, width: '20%' },
});
export default styles;
